import { AriaDescriber, FocusMonitor } from '@angular/cdk/a11y';
import { Directionality } from '@angular/cdk/bidi';
import { Overlay, ScrollDispatcher } from '@angular/cdk/overlay';
import { Platform } from '@angular/cdk/platform';
import {
  AfterViewChecked,
  Directive,
  ElementRef,
  Inject,
  Input,
  NgZone,
  Optional,
  ViewContainerRef
} from '@angular/core';
import {
  MatTooltip,
  MatTooltipDefaultOptions,
  MAT_TOOLTIP_DEFAULT_OPTIONS,
  MAT_TOOLTIP_SCROLL_STRATEGY
} from '@angular/material/tooltip';

@Directive({
  selector: '[vfsTruncate]'
})
export class TruncateDirective extends MatTooltip implements AfterViewChecked {
  @Input() truncateLimit = 10;

  constructor(
    private elementRef: ElementRef,
    matOverlay: Overlay,
    matElementRef: ElementRef,
    matScrollDispatcher: ScrollDispatcher,
    matViewContainerRef: ViewContainerRef,
    matNgZone: NgZone,
    matPlatform: Platform,
    matAriaDescriber: AriaDescriber,
    matFocusMonitor: FocusMonitor,
    @Inject(MAT_TOOLTIP_SCROLL_STRATEGY) matScrollStrategy: any,
    @Optional() matDir: Directionality,
    @Optional()
    @Inject(MAT_TOOLTIP_DEFAULT_OPTIONS)
    matDefaultOptions: MatTooltipDefaultOptions
  ) {
    super(
      matOverlay,
      matElementRef,
      matScrollDispatcher,
      matViewContainerRef,
      matNgZone,
      matPlatform,
      matAriaDescriber,
      matFocusMonitor,
      matScrollStrategy,
      matDir,
      matDefaultOptions
    );
  }

  ngAfterViewChecked(): void {
    this.checkEllipsis();
  }

  checkEllipsis() {
    const element = this.elementRef.nativeElement;
    if (
      typeof element.textContent === 'string' &&
      !element.textContent.includes('...') &&
      element.textContent.length > this.truncateLimit
    ) {
      this.message = element.textContent;
      element.textContent = element.textContent.substring(0, this.truncateLimit) + '...';
      element.classList.add('with-ellipsis');
    }
  }
}
